module.exports = __webpack_public_path__ + "static/22_tat2-82f9f375703d968315f0ec64c4e7406b.jpg";